<!--
/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
@if (pageBusy) {
  <div class="spinner-section">
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
<div style="position: relative; padding: 62px 24px 10px 24px;">
  <mat-card>
    <h2>Manage Your Notifications</h2><br/>
    <form [formGroup]="appNotificationForm">
      <div id="appNotificationForm-container">
        <div id="user-apps" class="appNotificationForm-container-child label-with-well">
          <div>
            <h3>Select From Your Apps</h3>
          </div>
          <div>
            <mat-form-field>
              <mat-select placeholder="Select" formControlName="app">
                @for (a of userApps; track a) {
                  <mat-option [value]="a">{{getFullAppName(a)}}</mat-option>
                }
              </mat-select>
              @if (appNotificationForm.get('app').hasError('required')) {
                <mat-error>
                  Please select an app
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        @if (SELECTION_LEVEL.APP.isActive) {
          <div>
            <mat-slide-toggle #apptoggle color="primary" [disabled]="!isAppSelected" [checked]="isReceivingForSelectedApp" (change)="appLevelSliderToggle(apptoggle.checked)">
              {{ apptoggle.checked ? 'Receiving' : 'Not Receiving' }}
            </mat-slide-toggle>
          </div>
        }
        @if ((SELECTION_LEVEL.GROUP.isActive || SELECTION_LEVEL.EVENT.isActive) && notificationGroups.length > 0) {
          <div id="app-groups"
            class="appNotificationForm-container-child label-with-well">
            <div>
              <h3>Notification Groups</h3>
            </div>
            <div id="app-groups-checkboxes" class="well">
              @for (g of notificationGroups; track g) {
                <mat-checkbox id="{{groupCheckBoxIdPrefix + g.id}}" [labelPosition]="checkboxPosition" [indeterminate]="g.isPartiallyOpted"
                  [checked]="g.isOptedByUser" (change)="groupChecked(g.id ,$event)" [title]="g.groupName">
                  {{g.groupName}}
                </mat-checkbox>
              }
            </div>
          </div>
        }
        @if (SELECTION_LEVEL.EVENT.isActive && notificationGroups.length > 0) {
          <div id="notification-events" class="appNotificationForm-container-child label-with-well">
            <div>
              <h3>Notification Events</h3>
            </div>
            <div>
              <small>Notifications opted by you are highlighted in blue.</small>
              <div class="well">
                @for (n of notificationEvents; track n) {
                  <app-notification-event-button [notificationEvent]="n" (clicked)="eventClicked($event)"></app-notification-event-button>
                }
              </div>
            </div>
          </div>
        }
        <div id="form-actions">
          <button mat-raised-button class="accent" (click)="undoChanges()">Undo Changes</button>
          <button mat-raised-button class="primary" (click)="submitForm()">Submit</button>
        </div>
      </div>
    </form>
    <button mat-button (click)="notifyThisUser()">Notify This User</button>
  </mat-card>
</div>

